import React, { useState, createContext, useEffect } from "react";
import Cookies from "js-cookie";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    isAuth: false,
    fetchingAuth: true,
    token: "",
    userAgentType: "",
    fullname: "",
    phoneNo: "",
    businessName: "",
    balance: 0,
    status: "",
    email: "",
  });

  const [sales, setSales] = useState({
    totalSales: 0,
    todaySales: 0,
  });

  function getUser() {
    const accessToken = Cookies.get("accessToken");

    if (accessToken) {
      setUser((prevUser) => ({
        ...prevUser,
        isAuth: true,
        fetchingAuth: false,
        token: accessToken,
      }));
    } else {
      setUser((prevUser) => ({
        ...prevUser,
        isAuth: false,
        fetchingAuth: false,
        token: "",
        userAgentType: "",
      }));
    }
  }

  function updateSalesStats(orderData) {
    const today = new Date().toISOString().split("T")[0];
    const filtered = orderData.filter((item) => {
      const itemDate = item.created_at?.split(" ")[0];
      return itemDate === today;
    });

    const totalSales = orderData.length;
    const todaySales = filtered.length;

    setSales({ totalSales, todaySales });
  }

  async function userInfo() {
    try {
      const response = await fetch(`${API_BASE_URL}/app/auth/user`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });

      if (response.status === 200) {
        const userdetails = await response.json();
        if (userdetails.user && userdetails.user[0]) {
          const userAgentType = userdetails.user[0].account_type;
          const wallet = userdetails.user[0].wallet || {};
          const email = userdetails.user[0].email;
          const fullname = userdetails.user[0].fullname;
          const phoneNo = userdetails.user[0].phone_no;
          setUser((prevUser) => ({
            ...prevUser,
            userAgentType,
            fullname: fullname || "",
            phoneNo: phoneNo || "",
            businessName: wallet.business_name || "",
            balance: wallet.balance || 0,
            status: wallet.status || "",
            email,
          }));
        } else {
          throw new Error("User details are missing");
        }
      } else {
        throw new Error(response.statusText);
      }
    } catch (error) {
      console.error("Failed to fetch user info:", error);
    }
  }

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    if (user.isAuth) {
      userInfo();
    }
  }, [user.isAuth]);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        getUser,
        userInfo,
        sales,
        setSales,
        updateSalesStats,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
